module.exports = __webpack_public_path__ + "static/media/regent.ac4baf86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regent.svg
// module id = 650
// module chunks = 0